module.exports = __webpack_public_path__ + "static/media/productos_otros_pepita_verde.af1f9d90.jpg";